import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {
    editCustomers,
    getCustomerDetail
} from "../../../API/helper";
import {ProgressSpinner} from "primereact/progressspinner";
import Header from "../../../components/header/Header";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import Lottie from "react-lottie-player";
import settingsAnimation from "../../../assets/settingsAnimation.json";

function CustomerDetail(props) {
    const { state } = useLocation();
    const toast = useRef(null);
    const [visible, setVisible] = useState(false);
    const [label,setLabel]=useState("")
    const [loading,setLoading]=useState(false)
    const [customerValue, setCustomerValue] = useState({});
    const navigate = useNavigate();
    const getCustomer = async ()=>{
        setLoading(true)
        await getCustomerDetail(state.id).then((res)=>{
            setCustomerValue(res.data.list)
            setLoading(false)
        })
    }

    const editCustomerData = async (admin_id) => {
        await editCustomers(customerValue,admin_id).then((response) =>{
                if(response.success){
                    toast.current.show({
                        severity: "success",
                        summary: "Successful",
                        detail: response.message,
                        life: 3000,
                    })
                    setTimeout(() => {
                        navigate("/customers")
                    }, 1000);
                }
                else{
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: response.message,
                        life: 3000,
                    })
                }

            }

        );
    };

    const onSubmit = ()=>{
            editCustomerData(state?.id)
    }
    useEffect(()=>{
        if(!state?.create){
            setLabel("Customer Details")
            getCustomer()
        }else{
            setLabel("Create New Customer")
        }
    },[])
    return (
        <div>
            {loading ? (
                <div className="settings-loader">
                    <Lottie
                        loop
                        animationData={settingsAnimation}
                        play
                        style={{ width: 400, height: 400 }}
                    />
                </div>
            ) :  <div>
                <Header items={[{ label: 'Customers' , url: '/customers'},{ label: label }]} />
                <div style={{padding:20,display:"flex",gap:20,backgroundColor:"#f8f9fa",border:"1px solid #dee2e6",margin:10}}>
                    <div>
                        <div className="admin-wrapper">
                            <div className="admin-info-wrapper">
                                <span>ID:</span>
                                <InputText disabled={true} value={customerValue.id} onChange={(e) => setCustomerValue({...customerValue,id:e.target.value})} />
                            </div>
                            <div className="admin-info-wrapper">
                                <span>Dev Dataset ID:</span>
                                <InputText disabled={true} value={customerValue.dev_dataset_id} onChange={(e) => setCustomerValue({...customerValue,dev_dataset_id:e.target.value})} />
                            </div>
                            <div className="admin-info-wrapper">
                                <span>Name:</span>
                                <InputText value={customerValue.name} onChange={(e) => setCustomerValue({...customerValue,name:e.target.value})} />
                            </div>
                            <div className="admin-info-wrapper">
                                <span>Created Date:</span>
                                <InputText disabled={true} value={customerValue.created_at} onChange={(e) => setCustomerValue({...customerValue,created_at:e.target.value})} />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{display:"flex",paddingRight:20,justifyContent:"flex-end",marginBottom:20}}>
                    <Button className="p-button-info"
                            onClick={()=>{onSubmit()
                            }}>{state?.create ? "Create New Customer":"Edit Customer Data"}</Button>
                </div>
                <div className="datatable-crud-demo">
                    <Toast ref={toast} />
                    <Dialog header="Chat Messages" visible={visible} draggable={false} blockScroll style={{ width: '40vw',marginLeft:50 }} onHide={() => setVisible(false)}>
                    </Dialog>
                </div>
            </div>}
        </div>

    )
}

export default CustomerDetail;